import { defineEntityContract } from 'shared/channels/entity';
import { DomainMessagesTypes } from 'shared/domain/messages/message';
import type {
  CreateDecisionRequest,
  CreateStageRequest,
  CreateWorkflowRequest,
  DeleteStageRequest,
  EditStageRequest,
  EditWorkflowRequest,
  ReorderStageRequest,
} from './requests';
import type { IssueWorkflowOutDto, WorkflowDecisionOutDto, WorkflowStageOutDto } from './types';

/** Outcomes of the changes come with their `uniqueId`; failures as `workflowError` / `stageError` / `decisionError`. */
export type WorkflowEvents = {
  [DomainMessagesTypes.allIssueWorkflows]: { hasAll?: boolean; items: IssueWorkflowOutDto[] };
  [DomainMessagesTypes.createdWorkflow]: IssueWorkflowOutDto;
  [DomainMessagesTypes.updatedWorkflow]: IssueWorkflowOutDto;
  [DomainMessagesTypes.createdStage]: WorkflowStageOutDto;
  [DomainMessagesTypes.updatedStage]: WorkflowStageOutDto;
  [DomainMessagesTypes.deletedStage]: WorkflowStageOutDto;
  [DomainMessagesTypes.reorderedStage]: WorkflowStageOutDto;
  [DomainMessagesTypes.createdDecision]: WorkflowDecisionOutDto;
  [DomainMessagesTypes.workflowError]: unknown;
  [DomainMessagesTypes.stageError]: unknown;
  [DomainMessagesTypes.decisionError]: unknown;
  [DomainMessagesTypes.clearData]: undefined;
  [DomainMessagesTypes.pullFailed]: undefined;
};

/** Each change resolves once queued; its outcome follows as an event with its `uniqueId`. */
export type WorkflowRequests = {
  createWorkflow: { request: CreateWorkflowRequest; response: void };
  editWorkflow: { request: EditWorkflowRequest; response: void };
  createStage: { request: CreateStageRequest; response: void };
  editStage: { request: EditStageRequest; response: void };
  deleteStage: { request: DeleteStageRequest; response: void };
  reorderStage: { request: ReorderStageRequest; response: void };
  createDecision: { request: CreateDecisionRequest; response: void };
};

export const workflowContract = defineEntityContract<IssueWorkflowOutDto, WorkflowEvents, WorkflowRequests>(
  'issueWorkflowsChannel',
  { collectionEvent: DomainMessagesTypes.allIssueWorkflows }
);
